

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ResponsavelAssociado} from '@/model/resource/ResponsavelAssociado'
import {ResponsavelAssociadoCollection} from '@/model/collection/ResponsavelAssociadoCollection'
import {ListResponsavelAssociadoSchema} from '@/schema/resource/ResponsavelAssociado/ListResponsavelAssociadoSchema'
import {CsvResponsavelAssociadoSchema} from '@/schema/resource/ResponsavelAssociado/CsvResponsavelAssociadoSchema'

@Component
export default class ListResponsavelAssociadoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelAssociadoSchema()
  collection = new ResponsavelAssociadoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelAssociado) {
    Helper.pushByName('editResponsavelAssociado', item.$id)
  }

  async removeItem(item: ResponsavelAssociado) {
    await new DialogRemove(item).confirm(() =>
      item.removeResponsavelAssociado()
    )
    await this.collection.listResponsavelAssociado()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelAssociadoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelAssociado()
    new CsvResponsavelAssociadoSchema().downloadCsv(csv.all())
  }
}
